import type { Action } from 'svelte/action';

export const clickOutside: Action<
	HTMLElement,
	void,
	{ 'on:outclick'?: (e: CustomEvent<MouseEvent>) => void }
> = (node) => {
	const handleClick = (event: MouseEvent) => {
		if (!node.contains(event.target as Node)) {
			node.dispatchEvent(new CustomEvent<MouseEvent>('outclick', { detail: event }));
		}
	};
	document.addEventListener('click', handleClick, true);
	return {
		destroy() {
			document.removeEventListener('click', handleClick, true);
		}
	};
};

export default clickOutside;
